import React, {CSSProperties} from 'react';

type LocationPinProps = {
    selected: boolean
    hover: boolean
}

export function LocationPin({selected, hover} : LocationPinProps) {

    const SIZE_NORMAL = 57;
    const SIZE_HOVER_SELECTED = 59;

    const pinPositioningStyle : CSSProperties = {
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
        cursor: 'pointer'
    };

    const size = (selected || hover) ? SIZE_HOVER_SELECTED : SIZE_NORMAL;
    const color = '#4368a1';

    return (
        <>
            <svg  xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 35.36" style={pinPositioningStyle}>
                <path fill={color} d="M12,0A12,12,0,0,0,0,12c0,2.66,1.57,6.71,4.93,12.73,2.29,4.1,4.57,7.58,4.67,7.72L11.25,35a.9.9,0,0,0,1.5,0l1.65-2.51c.09-.14,2.36-3.59,4.67-7.72C22.43,18.71,24,14.65,24,12A12,12,0,0,0,12,0Zm5.5,23.86c-2.28,4.08-4.51,7.47-4.6,7.61L12,32.83l-.9-1.36c-.09-.15-2.34-3.56-4.6-7.62C3.37,18.27,1.8,14.28,1.8,12a10.2,10.2,0,0,1,20.4,0C22.2,14.28,20.62,18.27,17.5,23.86ZM12,5.27a6.66,6.66,0,1,0,6.65,6.66A6.66,6.66,0,0,0,12,5.27Zm0,11.51a4.86,4.86,0,1,1,4.86-4.85A4.86,4.86,0,0,1,12,16.78Z"/>
            </svg>
        </>
    );
}
